import messages from "./messages.i18n";
import { PATHS } from "@constants/Paths";
import { ClipboardText, Dedupe, GlobeV2 as Globe, Headset, Heart, HomeV2, Robot, TrendingUpV2, UserCard, UserV2, UserWalking, } from "@piiqtechnologies/svg-icons";
export const NavigationListItemsConfig = (isAdmin) => {
    const mainItems = [
        {
            label: messages.home,
            path: PATHS.HOME,
            icon: HomeV2,
        },
        {
            label: messages.spaces,
            path: PATHS.SPACES,
            icon: Globe,
            color: "purple.400",
        },
        {
            label: messages.scanRequests,
            path: `${PATHS.SCAN_REQUESTS}/${PATHS.SCAN_REQUESTS_UPCOMING_SHOOTS}`,
            icon: ClipboardText,
            hideModePolicyAction: "scan_request_read" /* PolicyActions.SCAN_REQUEST_READ */,
        },
        {
            label: messages.sgt,
            path: PATHS.SGT,
            icon: UserWalking,
            premiumModePolicyAction: "SGT" /* PolicyActions.SGT */,
            iconSize: 22,
            color: "graphColors.orange",
        },
        {
            label: messages.users,
            path: PATHS.USERS,
            icon: UserCard,
            hideModePolicyAction: "accounts_read" /* PolicyActions.ACCOUNTS_READ */,
        },
        {
            label: messages.analytics,
            path: PATHS.ANALYTICS,
            hideModePolicyAction: "analytics_read" /* PolicyActions.ANALYTICS_READ */,
            icon: TrendingUpV2,
        },
        {
            label: messages.prospectIntelligence,
            path: PATHS.PROSPECT_INTELLIGENCE,
            icon: UserV2,
            hideModePolicyAction: "prospect_intelligence_read" /* PolicyActions.PROSPECT_INTELLIGENCE_READ */,
            premiumModePolicyAction: "Prospect Intelligence" /* PolicyActions.PROSPECT_INTELLIGENCE */,
        },
    ];
    if (isAdmin) {
        return [
            {
                label: messages.home,
                path: `${PATHS.ADMIN}/${PATHS.ADMIN_HOME}`,
                icon: HomeV2,
            },
            {
                label: messages.scanRequests,
                path: `${PATHS.ADMIN}/${PATHS.ADMIN_SCAN_REQUESTS}/${PATHS.SCAN_REQUESTS_ADMIN_REQUESTS}`,
                icon: ClipboardText,
                color: "primary.main",
            },
            {
                label: messages.contentServices,
                path: `${PATHS.ADMIN}/${PATHS.CONTENT_SERVICES}`,
                icon: Headset,
                color: "success.main",
            },
            {
                label: messages.dedupeUnits,
                path: `${PATHS.ADMIN}/${PATHS.DEDUPE_UNITS}`,
                icon: Dedupe,
                iconSize: 24,
                color: "orange.400",
            },
            {
                label: messages.accountHealth,
                path: `${PATHS.ADMIN}${PATHS.ACCOUNT_HEALTH}`,
                icon: Heart,
                color: "error.main",
            },
            {
                label: messages.assistantOnboarding,
                path: `${PATHS.ADMIN}/${PATHS.ADMIN_ASSISTANT_ONBOARDING}`,
                icon: Robot,
                color: "purple.400",
            },
        ];
    }
    return mainItems;
};
